import qs from "qs";

import TdsAndRiderPayoutJobsApi from "../../services/api/tdsAndRiderPayoutJobs";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getPath } from "../../utils";

const handleError = (err) => {
  console.error(
    "[handle-error] Error In TDS And Rider Payout Jobs Actions",
    err
  );
};

const setTdsAndRiderPayoutJobsList = (payload) => {
  return {
    type: ActionTypes.SET_TDS_AND_RIDER_PAYOUT_JOBS_LIST,
    payload,
  };
};

const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_TDS_AND_RIDER_PAYOUT_JOBS,
    payload,
  };
};

export const getJobsList = (jobType) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const payload = { job_name: jobType };
    const queryParams = qs.stringify(payload, { addQueryPrefix: true });
    const response = await TdsAndRiderPayoutJobsApi.getJobs(queryParams);
    dispatch(setLoader(false));
    if (response) {
      const jobs = getPath(response, "jobs", []);
      dispatch(setTdsAndRiderPayoutJobsList(jobs));
    } else {
      dispatch(resetState({ state: "jobs" }));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(resetState({ state: "jobs" }));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const triggerJob = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await TdsAndRiderPayoutJobsApi.triggerJob(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
  }
};
